import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {DetailLabel} from '../mapping-classes/detail-label';
import {ButtonData} from '../mapping-classes/button-data';

const ERROR_TEXT = 'Geen detail gegevens gevonden.';

export class Internationalcashmanagement implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    this.title = '...';
    this.buttons = [];
    this.restrictedData = false;
    if (response && response?.detailsViewObject) {
      this.title = response.detailsViewObject.commercialProductTypeName || 'ICM';
      this.actualityDateTime = response.detailsViewObject.actualityDateTime;
      this.addButtons(response);
    } else {
      this.createErrorMessage(response);
    }
    if (response) {
      if (response.listOfError && response.listOfError.length) {
        this.createErrorMessage(response);
      } else {
        this.panels = [];
        this.nameValues = [];
        this.addPanels();
        this.setNameAndValues(response);
        this.fillValues(response);
      }
    } else {
      this.errorText = ERROR_TEXT;
    }

  }

  addButtons(res) {
    const data = this.getExtraData(res.detailsViewObject);
    this.buttons.push(new ButtonData(
      'cockpiturl',
      null,
      null,
      null,
      'B&O Cockpit',
      null,
      'boc-url', data));
  }

  getExtraData(res) {
    return {
      arrangementNumber: res.arrangementNumber,
      administrationCode: res.administrationCode,
      accountNumber: res.multibankAccount,
      accountCurrency: res.currency,
      defaultBic: res.defaultBic,
      accountType: res.accountType,
    };
  }

  addPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
  }

  setNameAndValues(response?) {
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.addLabelToProductsDetailsPanel(productDetailsPanel);

    const productAgreementPanel: DetailPanel = this.panels[1];
    this.addSubHeaderToPanel(productAgreementPanel, 'Rekening');
    this.addSubHeaderToPanel(productAgreementPanel, 'Transactie informatie');
    this.addLabelsToProductAgreementPanel(productAgreementPanel);
  }

  fillValues(response: any) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.fillValuesToProductDetailsPanel(productDetailsPanel, obj);

    const productAgreementPanel: DetailPanel = this.panels[1];
    this.fillValuesToProductAgreementPanel(productAgreementPanel, obj);
  }

  private addLabelToProductsDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('multibankAccount', new DetailLabel('Rekeningnummer'));
    productDetailsPanel.nameAndValues.set('accountHolderName', new DetailLabel('Tenaamstelling rekening'));
    productDetailsPanel.nameAndValues.set('defaultBic', new DetailLabel('Default BIC'));
    productDetailsPanel.nameAndValues.set('fiName', new DetailLabel('Naam bank'));
    productDetailsPanel.nameAndValues.set('branchCountryCode', new DetailLabel('Land bank'));
    productDetailsPanel.nameAndValues.set('currency', new DetailLabel('Muntsoort'));
    productDetailsPanel.nameAndValues.set('accountActiveIndicator', new DetailLabel('Status'));
    productDetailsPanel.nameAndValues.set('customerChargesAccount', new DetailLabel('Afrekenrekening'));
  }

  private addLabelsToProductAgreementPanel(physicalCardsPanel: DetailPanel) {
    physicalCardsPanel.subPanels[0].nameAndValues.set('startDate', new DetailLabel('Start rekening'));
    physicalCardsPanel.subPanels[0].nameAndValues.set('endDate', new DetailLabel('Einde rekening'));
    physicalCardsPanel.subPanels[0].nameAndValues.set('accountType', new DetailLabel('Rekening type'));

    physicalCardsPanel.subPanels[1].nameAndValues.set('paymentInitiationAllowed', new DetailLabel('Initiatie'));
    physicalCardsPanel.subPanels[1].nameAndValues.set('mt94xbic', new DetailLabel('Verantwoording BIC'));
    physicalCardsPanel.subPanels[1].nameAndValues.set('mt101bic', new DetailLabel('Initiatie BIC'));
  }

  private fillValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('multibankAccount').setValue(obj.multibankAccount);
    productDetailsPanel.nameAndValues.get('accountHolderName').setValue(obj.accountHolderName);
    productDetailsPanel.nameAndValues.get('currency').setValue(obj.currency);
    productDetailsPanel.nameAndValues.get('fiName').setValue(obj.fiName);
    productDetailsPanel.nameAndValues.get('branchCountryCode').setValue(obj.branchCountryCode);
    productDetailsPanel.nameAndValues.get('defaultBic').setValue(obj.defaultBic);
    productDetailsPanel.nameAndValues.get('accountActiveIndicator').setValue(obj.accountActiveIndicator ? 'Actief' : 'Inactief');
    productDetailsPanel.nameAndValues.get('customerChargesAccount').setValue(obj.customerChargesAccount);
  }

  private fillValuesToProductAgreementPanel(physicalCardsPanel: DetailPanel, obj) {
    physicalCardsPanel.subPanels[0].nameAndValues.get('startDate').setValue(obj.startDate);
    physicalCardsPanel.subPanels[0].nameAndValues.get('endDate').setValue(obj.endDate);
    physicalCardsPanel.subPanels[0].nameAndValues.get('accountType').setValue(obj.accountType);

    physicalCardsPanel.subPanels[1].nameAndValues.get('paymentInitiationAllowed').setValue(obj.paymentInitiationAllowed ? 'Ja' : 'Nee');
    physicalCardsPanel.subPanels[1].nameAndValues.get('mt94xbic').setValue(obj.mt94xbic);
    physicalCardsPanel.subPanels[1].nameAndValues.get('mt101bic').setValue(obj.mt101bic);
  }

  private addSubHeaderToPanel(panel: DetailPanel, title) {
    panel.subPanels.push(new DetailPanel(title));
  }

  createErrorMessage(response) {
    if (response) {
      if (response.listOfError && response.listOfError.length !== 0) {
        if (response.listOfError[0].code === 'CIV_F025') {
          this.errorText = ERROR_TEXT;
        } else if (response.listOfError[0].code) {
          this.errorText = 'Product niet gevonden.';
        }
      }
    } else {
      this.errorText = ERROR_TEXT;
    }

  }
}
